// extracted by mini-css-extract-plugin
module.exports = {"priceType":"_93444fe79c--priceType--2eN3E"};